





























































































































import { Component, Watch } from "vue-property-decorator";
import Vue from "vue";
import { userModule } from "@/store/modules/user";
import ModalKonfirmasi from "@/components/modal/KonfirmasiLogout.vue";
import { appModule } from "./store/modules/app";
import ModalAlert from "@/components/modal/ModalAlert.vue";
import ModalTandaTangan from "@/components/modal/ModalTandaTangan.vue";
import CriticalLabAlarmListener from "@/components/critical-lab-result/CriticalLabAlarmListener.vue";
import OrderBankDarahAlarmListener from "@/components/bank-darah/OrderBankDarahAlarmListener.vue";
import OrderBankDarahStore from "@/store/modules/OrderBankDarahStore";

import TheNavigationDrawer from "./components/layouts/TheNavigationDrawer.vue";
import TheAppBar from "./components/layouts/TheAppBar.vue";
import { storeUnit } from "./store/modules/unit";
import {
  getReferenceData,
  getUserPreferenceData
} from "@/utility/ReferenceDataHelper";
import RefreshPageClass from "@/utility/RefreshPageClass";
import ClientSystemStore from "./store/modules/ClientSystemStore";
import IdleJs from "idle-js";
import User from "./services/User";
import AnnouncementModal from "@/components/modal/AnnouncementModal.vue";
//panduan
import { PanduanStoreModule } from "@/store/modules/PanduanStore";
import PanduanDrawer from "@/components/PanduanDrawer.vue";
import MasterReferensi from "./store/modules/new/MasterReferensi";
import {
  resolvePrimaryMenu,
  LAPORAN_GROUP,
  MANAJEMEN_MENU,
  URM_GROUP,
  MUTU_PPI_MENU,
  ALAT_REUSE_GROUP,
  SUPERADMIN_GROUP,
  AUDIT_TRAIL_MENU_ITEM,
  SATUSEHAT_MONITOR_MENU_ITEM,
  MASTER_REFERENSI_MENU_ITEM,
  MPP_GROUP,
  ORDER_GIZI_GROUP,
  BANK_DARAH_SERAH_TERIMA_GROUP,
  DASHBOARD_DOKTER_MENU_ITEM,
  SKRINING_PENGUNJUNG_GROUP,
  SKRINING_PENGUNJUNG_INPUT_MENU_ITEM,
  SKRINING_PENGUNJUNG_LAPORAN_MENU_ITEM,
  ANTIMIKROBA_RESERVE_MENU_ITEM,
  RENCANA_KONTROL_SRK_MENU_ITEM,
  filterMenuByAccess,
  MenuAccessContext,
  SidebarMenuItem
} from "@/config/sidebar-menu";
import { FormAction } from "@/utils/form-access";
import { daftarPasienRouteName, isUnitAdministrasi } from "@/utils/unit";

@Component({
  components: {
    TheNavigationDrawer,
    TheAppBar,
    ModalKonfirmasi,
    ModalAlert,
    ModalTandaTangan,
    CriticalLabAlarmListener,
    OrderBankDarahAlarmListener,
    AnnouncementModal,
    PanduanDrawer
  }
})
export default class App extends Vue {
  updateNews = [];
  isShowUpdateNewsModal = false;

  get signedIn() {
    return userModule.isSignedIn;
  }

  get user() {
    return userModule.user;
  }

  get modeSkriningPengunjung(): boolean {
    return this.signedIn && userModule.isModeSkriningPengunjung;
  }

  get bisaOrderBankDarah(): boolean {
    return (
      this.signedIn &&
      (userModule.loginUnitId || "").trim() === "35" &&
      userModule.hasPrivilege("bank_darah_order", "view")
    );
  }

  @Watch("bisaOrderBankDarah", { immediate: true })
  changedBisaOrderBankDarah(val: boolean) {
    if (val) OrderBankDarahStore.fetchCount();
  }

  get showAlert() {
    return appModule.alert;
  }

  get errItem() {
    return {
      errorMsg: appModule.alertMessage,
      errorIcon: "mdi-alert-circle-outline"
    };
  }

  toUserProfile() {
    this.$router.push({ name: "user-profile" });
  }

  get showPasswordAlert() {
    return this.user?.is_password_expired || this.user?.is_password_reseted;
  }

  rpc = null;

  public drawer = window.innerWidth > 960;
  public rightDrawer = false;

  private menuItem = "";
  modalOpenKonfirmasi = false;
  msgConfirm = "";
  _timerId;

  created() {
    ClientSystemStore.getWhoAmI();

    //  [App.vue specific] When App.vue is first loaded start the progress bar
    this.$Progress.start();
    //  hook the progress bar to start before we move router-view
    this.$router.beforeEach((to, _from, next) => {
      //  does the page we want to go to have a meta.progress object
      if (to.meta.progress !== undefined) {
        const meta = to.meta.progress;
        // parse meta tags
        this.$Progress.parseMeta(meta);
      }

      //  start the progress bar
      this.$Progress.start();

      //  continue to next page
      next();
    });
    //  hook the progress bar to finish after we've finished moving router-view
    this.$router.afterEach(to => {
      // this.$router.afterEach((to, from) => {
      if (to.name !== "ErrorPage") {
        this.menuItem = to.name;
      }
      //  finish the progress bar
      this.$Progress.finish();
    });
  }

  async mounted() {
    if (this.signedIn) {
      // yg ini kepake buat pendaftaran
      // storeReferensiUnit.getUnit();

      document.title = `${userModule.user?.nama}@RME_RSPS (emedika)`;

      getUserPreferenceData();

      userModule.getProfile();

      if (!this.modeSkriningPengunjung) {
        getReferenceData();

        // ambil data panduan dari store
        PanduanStoreModule.fetchPanduan();
      }
    } else {
      document.title = `RME_RSPS (emedika)`;
    }

    this.changedSignedIn(this.signedIn);

    if (!this.modeSkriningPengunjung && !storeUnit.unitRanap.length) {
      storeUnit.getUnitRanap();
    }

    this.rpc = new RefreshPageClass();

    await this.rpc.initVersionCheck();

    if (!this.modeSkriningPengunjung && MasterReferensi.holidays.length < 1) {
      MasterReferensi.getHolidays();
    }
  }

  idle = new IdleJs({
    idle: 60 * 60 * 1000, // idle time in ms
    events: ["mousemove", "keydown", "mousedown", "touchstart", "scroll"], // events that will trigger the idle resetter
    onIdle: () => {
      if (!this.isShowTimeoutConfirm) {
        this.signOut();
      } else {
        this.idle.reset();
      }
    }, // callback function to be executed after idle time
    onActive: () => {}, // callback function to be executed after back form idleness
    // onHide: , // callback function to be executed when window become hidden
    // onShow: , // callback function to be executed when window become visible
    keepTracking: true, // set it to false if you want to be notified only on the first idleness change
    startAtIdle: true // set it to true if you want to start in the idle state
  });

  @Watch("signedIn")
  changedSignedIn(val) {
    if (val) {
      this.idle.start();

      if (userModule.isModeSkriningPengunjung) return;

      User.getAnnouncement(userModule.user?.id).then(res => {
        this.updateNews = res.data;

        if (res.data.length > 0) {
          this.isShowUpdateNewsModal = true;
        }
      });
    } else {
      this.idle.stop();
    }
  }

  interval = null;
  sc = 0;
  isShowTimeoutConfirm = false;
  timeoutConfirmMsg = null;
  confirmTimeout = null;
  dialogTimeout = 10;
  dialogCountDown = null;
  dialogCountDownInterval = null;

  staySignIn() {
    clearTimeout(this.confirmTimeout);
    clearInterval(this.dialogCountDownInterval);

    this.isShowTimeoutConfirm = false;
    this.idle.reset();
  }

  logSessionOut() {
    this.logout();

    clearTimeout(this.confirmTimeout);
    this.stopDialogCountdown();
    this.isShowTimeoutConfirm = false;
  }

  signOut() {
    if (this.signedIn) {
      this.timeoutConfirmMsg =
        "Sesi aktif Anda telah habis. Klik <b>Lanjutkan</b> bila masih ingin di melanjutkan sesi. Atau klik <b>Keluar</b> untuk logout (keluar) dari aplikasi.";
      this.isShowTimeoutConfirm = true;

      this.dialogCountDown = this.dialogTimeout;
      this.startDialogCountdown();
      this.startSessTimeoutCd(this.dialogTimeout);
    }
  }

  stopDialogCountdown(num: number = null) {
    clearInterval(this.dialogCountDownInterval);
    clearTimeout(this.confirmTimeout);
    this.dialogCountDown = num;
  }

  startDialogCountdown() {
    this.startSessTimeoutCd(this.dialogCountDown);
    clearInterval(this.dialogCountDownInterval);
    this.dialogCountDownInterval = setInterval(() => {
      this.dialogCountDown -= 1;
    }, 1000);
  }

  startSessTimeoutCd(num: number) {
    clearTimeout(this.confirmTimeout);
    this.confirmTimeout = setTimeout(() => {
      this.logSessionOut();
    }, num * 1000);
  }

  mouseoverConfirmDialog() {
    this.stopDialogCountdown(this.dialogCountDown);
  }

  mouseleaveConfirmDialog() {
    this.startDialogCountdown();
  }

  get versionUpdated() {
    return this.rpc?.versionUpdated;
  }

  get currentVersionHash() {
    return this.rpc?.currentHash;
  }

  get items(): AppMenu[] {
    const menuAccess: MenuAccessContext = {
      canAccess: (code: string, action?: FormAction) =>
        userModule.canAccessForm(code, action ?? "view"),
      hasPrivilege: (domain: string, action: string) =>
        userModule.hasPrivilege(domain, action),
      hasPrivilegePrefix: (prefix: string, action: string) =>
        userModule.hasPrivilegePrefix(prefix, action),
      isSuperAdmin: userModule.isSuperAdmin
    };

    if (this.modeSkriningPengunjung) {
      return filterMenuByAccess(
        [
          SKRINING_PENGUNJUNG_INPUT_MENU_ITEM,
          SKRINING_PENGUNJUNG_LAPORAN_MENU_ITEM
        ],
        menuAccess
      ) as AppMenu[];
    }

    const badgeOrder = OrderBankDarahStore.badgeText;
    const items: SidebarMenuItem[] = filterMenuByAccess(
      resolvePrimaryMenu(userModule.loginUnitId || ""),
      menuAccess
    ).map(item =>
      this.bisaOrderBankDarah && item.link === "daftar-pasien"
        ? { ...item, badge: badgeOrder, badgeBlink: !!badgeOrder }
        : item
    );

    const daftarPasienLink = daftarPasienRouteName(userModule.loginUnitId);
    const posisiDaftarPasien = items.findIndex(
      item => item.link === daftarPasienLink
    );
    items.splice(
      posisiDaftarPasien >= 0 ? posisiDaftarPasien + 1 : Math.min(1, items.length),
      0,
      ...filterMenuByAccess([ORDER_GIZI_GROUP], menuAccess)
    );

    if (this.bisaOrderBankDarah) {
      const posisi = items.findIndex(item => item.link === daftarPasienLink);
      items.splice(
        posisi >= 0 ? posisi + 1 : Math.min(1, items.length),
        0,
        ...filterMenuByAccess([BANK_DARAH_SERAH_TERIMA_GROUP], menuAccess)
      );
    }

    if (userModule.user?.map_cdoc) {
      items.unshift(DASHBOARD_DOKTER_MENU_ITEM);
    }

    items.push(
      ...filterMenuByAccess([ANTIMIKROBA_RESERVE_MENU_ITEM], menuAccess)
    );

    const unitAdministrasi = isUnitAdministrasi(userModule.loginUnitId);

    if (!unitAdministrasi) {
      items.push(...filterMenuByAccess([LAPORAN_GROUP], menuAccess));

      items.push({
        icon: "mdi-folder-multiple-image",
        title: "Berkas RM Manual",
        vertical:
          "Unggah & kelola berkas manual RM pasien (scan RM lama, KTP, KK, BPJS)",
        link: "berkas-rm"
      });
    }

    items.push(...filterMenuByAccess([ALAT_REUSE_GROUP], menuAccess));

    if (userModule.isSuperAdmin) {
      items.push(SUPERADMIN_GROUP);
    } else {
      items.push(
        ...filterMenuByAccess(
          [AUDIT_TRAIL_MENU_ITEM, SATUSEHAT_MONITOR_MENU_ITEM],
          menuAccess
        )
      );
    }

    items.push(
      ...filterMenuByAccess([MASTER_REFERENSI_MENU_ITEM], menuAccess)
    );

    items.push(...filterMenuByAccess([MPP_GROUP], menuAccess));

    items.push(...filterMenuByAccess([SKRINING_PENGUNJUNG_GROUP], menuAccess));

    items.push(...filterMenuByAccess(MUTU_PPI_MENU, menuAccess));

    items.push(...filterMenuByAccess([URM_GROUP], menuAccess));

    if (userModule.user.role?.id <= 2) {
      items.push(...filterMenuByAccess(MANAJEMEN_MENU, menuAccess));
    }

    if (userModule.canAccessRevisionInbox) {
      items.push({
        icon: "mdi-file-edit-outline",
        title: "Pengajuan Akses Revisi EMR",
        vertical:
          "Persetujuan Akses Revisi Rekam Medis (Tim Rekam Medis / Super Admin)",
        link: "pengajuan-akses-revisi"
      });
    }

    if (!unitAdministrasi) {
      items.push({
        icon: "mdi-clipboard-list-outline",
        title: "Daftar Register Pasien",
        vertical: "Daftar register pasien dirawat / sudah pulang, semua unit",
        link: "daftar-register-pasien"
      });
    }

    items.push(RENCANA_KONTROL_SRK_MENU_ITEM);

    return items as AppMenu[];
  }

  get activeMenuItem() {
    return this.menuItem;
  }

  get bottomSnackbar() {
    return appModule.snackbar;
  }
  set bottomSnackbar(val) {
    appModule.setSnackbar(val);
  }

  get bottomSnackbarText() {
    return appModule.notice;
  }

  get alertSnackbar() {
    return appModule.snackbaralert;
  }
  set alertSnackbar(val) {
    appModule.setSnackbaralert(val);
  }

  get alertSnackbarText() {
    return appModule.noticealert;
  }

  get showRegisterHF() {
    return userModule.user.unit_group_id == "27";
  }

  handleNavigation(item: TODO) {
    this.menuItem = item.title;
    this.$router.push({
      name: item.link,
      query: item.query
    });
  }

  logout() {
    userModule.logout();

    this.$nextTick(() => {
      this.$router.push("login");
    });
  }

  handleUserActions(item: TODO) {
    this.menuItem = item.title;
    if (item.title === "Logout") {
      this.modalOpenKonfirmasi = true;
      this.msgConfirm = "Anda yakin ingin keluar aplikasi?";
    } else {
      this.$router.push(item.link);
    }
  }

  public guideToggled = false;
}
